import type { CSSProperties } from 'react';

/** Cosmos modal width tokens (see globals.css --wf-mdl-*). */
export type ModalWidthVar =
  | '--wf-mdl-w'
  | '--wf-mdl-payout-w'
  | '--wf-mdl-withdraw-w'
  | '--wf-mdl-game-w'
  | '--wf-mdl-wide-w'
  | '--wf-mdl-guide-w';

export const MODAL_VIEWPORT_MAX = 'var(--wf-mdl-viewport-max)';
export const MODAL_MAX_H = 'var(--wf-mdl-max-h)';
export const MODAL_TOAST_MAX_WIDTH = 'min(var(--wf-mdl-w), var(--wf-mdl-viewport-max))';
export const MODAL_LIST_MAX_H = 'var(--wf-mdl-list-max-h)';

export const MODAL_Z = {
  deposit: 'var(--wf-z-modal-deposit)',
  pwa: 'var(--wf-z-modal-pwa)',
  nested: 'var(--wf-z-modal-nested)',
  overlay: 'var(--wf-z-modal-overlay)',
  popup: 'var(--wf-z-popup)',
  tour: 'var(--wf-z-tour)',
  security: 'var(--wf-z-modal-security)',
} as const;

export const MODAL_PANEL_CLASS =
  'relative cosmos-modal-panel flex flex-col w-full min-h-0 overflow-hidden';

export const MODAL_BACKDROP_SHELL_CLASS =
  'fixed inset-0 z-[var(--wf-z-modal-nested)] flex items-center justify-center cosmos-modal-backdrop p-4';

export const MODAL_BACKDROP_INNER_CLASS = 'absolute inset-0 cosmos-modal-backdrop';

/** Width + viewport cap only. */
export function modalWidthStyle(widthVar: ModalWidthVar): CSSProperties {
  return {
    width: `var(${widthVar})`,
    maxWidth: MODAL_VIEWPORT_MAX,
  };
}

/** Full inline panel sizing (width, pad, gap, radius). */
export function modalPanelStyle(
  widthVar: ModalWidthVar,
  extra?: CSSProperties
): CSSProperties {
  return {
    ...modalWidthStyle(widthVar),
    padding: 'var(--wf-mdl-pad)',
    gap: 'var(--wf-mdl-gap)',
    borderRadius: 'var(--wf-mdl-radius)',
    ...extra,
  };
}
